import { ref, onErrorCaptured } from "vue";
export default {
  name: "SuspenseWithError",
  setup: function setup() {
    var error = ref(null);
    onErrorCaptured(function (e) {
      error.value = e;
      return true;
    });
    return {
      error: error
    };
  }
};